module.exports = __webpack_public_path__ + "static/media/4.8.7fc09f83.png";